<template lang="pug">
.container.grid-lg.py-2
  load-manager(:status="status")
    div(v-if="current")
      show-analise(:analise="current")
      .no-print
        .my-2.py-2
          span(v-if="current.situacao === 'aguardando'")
            router-link.btn.btn-success.mr-1(:to="{ name: 'app.analises.minhasAnalises.show.concluir' }")
              btn-content(icon="fa fa-eye", label="Concluir")
            router-link.btn.btn-primary.mr-1(:to="{ name: 'app.analises.minhasAnalises.show.reanalise' }")
              btn-content(icon="fa fa-refresh", label="Reanálise")
            router-link.btn.mr-1(:to="{ name: 'app.analises.minhasAnalises.show.reabertura' }")
              btn-content(icon="fa fa-recycle", label="Reabrir OS-m")
          a.btn.btn-link.btn-sm.no-print(
            onclick="window.print()"
          )
            i.fa.fa-print
            |  Imprimir
        router-view
</template>

<script>
import showMixin, { vuexDefaultMapping } from "@/mixins/show"
import ShowAnalise from "../ShowAnalise.vue"

export default {
  vuex: {
    "analises/minhasAnalises": vuexDefaultMapping,
  },
  components: { ShowAnalise },

  mixins: [showMixin],
}
</script>
